<template lang="html">

  <section class="all-games-list">
    <GameCollection :games="games" :headline="headline"
                    :profile_pic_url="profile_pic_url" :showRating="showRating" :showUserRating="showUserRating"
                    :thumb_url="thumb_url" :type="type"
                    :user="user" :voteable="voteable">

    </GameCollection>
    <infinite-loading @infinite="infiniteHandler" v-if="nextPageUrl"></infinite-loading>
  </section>

</template>

<script lang="js">

import GenreService from "../../services/GenreService";
import GameService from "../../services/GameService";
import UserService from "../../services/UserService";
import InfiniteLoading from 'vue-infinite-loading';
import axios from 'axios';
import authHeader from "../../services/auth-header";
import GameListService from "../../services/GameListService";
import GameCollection from "@/components/games/GameCollection.vue";

export default {
  name:       'all-games-list',
  props:      ['user'],
  components: {
    GameCollection,
    InfiniteLoading
  },
  mounted () {

  },
  created () {
    this.type = this.$route.params.type;
    this.id   = this.$route.params.id;
    this.getGames();
  },
  data () {
    return {
      'type':            "",
      'id':              0,
      'headline':        "",
      'games':           [],
      'voteable':        true,
      'showRating':      true,
      'showUserRating':  false,
      'thumb_url':       window.api_url + "/storage/image/game/thumb_",
      'profile_pic_url': window.api_url + "/storage/image/user/",
      'nextPageUrl':     "",
    }
  },
  methods:  {
    getGames () {
      switch (this.type) {
        case 'genre': {
          if (this.user) {
            GenreService.getGamesAuth(this.id)
                        .then(res => {
                          //this.headline.loaded = true;
                          this.headline    = res.data.name;
                          this.games       = res.data.games.data;
                          this.nextPageUrl = res.data.games.next_page_url;
                        })
                        .catch(err => console.log(err));
          } else {
            GenreService.getGames(this.id)
                        .then(res => {
                          //this.headline.loaded = true;
                          this.headline    = res.data.name;
                          this.games       = res.data.games.data;
                          this.nextPageUrl = res.data.games.next_page_url;
                        })
                        .catch(err => console.log(err));
          }
          break;
        }
        case 'you': {
          UserService.getRatings(50)
                     .then(res => {
                       res.data.games.data.forEach(rating => {
                         rating.game.user_rating = parseFloat(rating.stars);
                         this.games.push(rating.game);
                       });
                       this.headline       = "Deine Spiele";
                       this.showUserRating = true
                       this.nextPageUrl    = res.data.games.next_page_url;
                     })
                     .catch(err => console.log(err));
          break;
        }
        case 'user': {
          UserService.getRatingsById(this.id, 50)
                     .then(res => {
                       this.voteable = false;
                       res.data.games.data.forEach(rating => {
                         rating.game.user_rating = parseFloat(rating.stars);
                         this.games.push(rating.game);
                       });
                       this.headline       = "Spiele von " + res.data.name;
                       this.showUserRating = true;
                       this.nextPageUrl    = res.data.games.next_page_url;
                     })
                     .catch(err => console.log(err));
          break;
        }
        case 'yourWishlist': {
          GameListService.getWishlist(50)
                         .then(res => {
                           this.showRating  = false;
                           this.voteable    = false;
                           this.games       = res.data.games.data;
                           this.headline    = res.data.wishlist.name;
                           this.nextPageUrl = res.data.games.next_page_url;
                         })
                         .catch(err => console.log(err));
          break;
        }
        case 'wishlist': {
          GameListService.getWishlistById(50, this.id)
                         .then(res => {
                           this.showRating  = false;
                           this.voteable    = false;
                           this.games       = res.data.games.data;
                           this.headline    = res.data.wishlist.name + " von " + res.data.username;
                           this.nextPageUrl = res.data.games.next_page_url;
                         })
                         .catch(err => console.log(err));
          break;
        }
        case 'recently': {
          UserService.getRecentlyPlayed(50)
                     .then(res => {
                       this.showRating     = true;
                       this.showUserRating = true;
                       this.voteable       = false;
                       this.games          = res.data.data;
                       this.headline       = 'Von Freunden zuletzt gespielt';
                       this.nextPageUrl    = res.data.next_page_url;
                     })
        }
      }
    },
    rate (value, game) {
      GameService.rate(game.id, value)
                 .then(res => {
                   game.rating = res.data.average;
                 })
                 .catch(() => {

                 });
    },
    infiniteHandler ($state) {
      if (this.nextPageUrl) {
        axios.get(this.nextPageUrl, {headers: authHeader()})
             .then(res => {
               let temp;
               console.log(res.data.games);
               console.log(res.data.games !== undefined);
               if (res.data.games !== undefined) {
                 this.nextPageUrl = res.data.games.next_page_url;
                 temp             = res.data.games.data;
               } else {
                 this.nextPageUrl = res.data.next_page_url;
                 temp             = res.data.data;
               }
               temp.forEach(element => {
                 this.games.push(element);
               });
               $state.loaded();
             })
             .catch(err => console.log(err));
      }
    },
  },
  computed: {}
  ,
}


</script>

<style scoped lang="scss">
.all-games-list {

}

.game_card {
  margin-bottom: 0;
  margin-left: 0;
}

.game_rating {
  margin-left: 8px;
}

.game_rating .v-icon {
  width: 40px;
}
</style>
